/* Maison: agregar un accesorio desde el carrito sin salir del carrito */
  (function () {
    if (window.__maisonCartAddons) return;
    window.__maisonCartAddons = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    // Accesorios con talle: se abre la vista rápida, así que primero se cierra el carrito (si no queda tapada)
    document.addEventListener('click', function (event) {
      var choose = event.target instanceof Element && event.target.closest('.mcart-addons .mqv-btn');
      if (!choose) return;
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.close === 'function') drawer.close();
    }, true);

    document.addEventListener('click', function (event) {
      var button = event.target instanceof Element && event.target.closest('[data-addon-variant]');
      if (!button || button.classList.contains('is-loading')) return;
      event.preventDefault();
      button.classList.add('is-loading');
      var variantId = button.getAttribute('data-addon-variant');

      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          button.classList.add('is-added');
          var update = new Event('cart:update', { bubbles: true });
          update.detail = { resource: cart, sourceId: 'maison-cart-addons', data: { source: 'maison-cart-addons', itemCount: cart.item_count, variantId: String(variantId) } };
          document.dispatchEvent(update);
        })
        .catch(function () {
          button.classList.remove('is-loading');
        });
    });
  })();
